module.exports = "\r\n#rtoutlet{\r\n  background-color: red !important;\r\n}\r\n/* #047804 !important; */\r\n"